export default __webpack_public_path__ + "static/banner-qa-3e1e5e398ab1978aa923cfb83181760b.jpg";